import React from 'react';
// @ts-ignore
import Parse from 'parse';

interface IProps {
  hideModal?:any;
}
interface IState {
  name?:any;
	email?:any;
	dateOfPurchase?:any;
	retailer?:any;
	productsPurchased?:any;
	tShirtSize?:any;
	messageSent?:any;
}

class HolidayForm extends React.Component<IProps> {
	public state: IState;

	constructor(props:any) {
      super(props);
      this.state = {
          name: '',
          email:'',
          dateOfPurchase:'',
          retailer:'',
          productsPurchased:''
      };
  }
  public handleNameChange = (e:any) =>{
    var name = e.target.value;
    this.setState({
      name:name
    })
  }
  public handleEmailChange = (e:any) =>{
    var email = e.target.value;
    this.setState({
      email:email
    })
  }
  public handleTShirtSizeChange = (e:any) =>{
    var tShirtSize = e.target.value;
    this.setState({
      tShirtSize:tShirtSize
    })
  }
  public submitForm = () => {
    if(!this.state.name || !this.state.email || !this.state.tShirtSize){
      alert('Please complete all fields')
    }
    else{
      Parse.Cloud.run('holidayEntryFormSubmitted',
      { name: this.state.name,
        email: this.state.email,
        tShirtSize: this.state.tShirtSize,
        website:"hyperlite.com"
      }).then(() => {
        this.setState({
          messageSent:true,
          name: '',
          email: '',
          tShirtSize: ''
        })
				setTimeout(() => {
					if(this.props.hideModal){
						this.props.hideModal()
					}
				}, 1000);
      });
    }
  }

	public render(): JSX.Element {
    console.log('modal town')
		return(
      <div className="section-paddding background-image-fill large-padding" style={{backgroundColor:'#C30f16'}}>
        <div className="full-width centered-text">
          <h3 className="white full-width" style={{paddingTop:"5%"}}>{'Holiday Giveaway'}</h3>
          <p className="white full-width">{'Only one entry allowed per day'}</p>
        </div>
        <div className="small-max-width-container small-padding" style={{marginTop:"2%"}}>
          {!this.state.messageSent && <div>
            <h4 className="white full-width centered-text">{'Enter for your chance to win free gear'}</h4>
            <p className="form-label white">{'Name'}</p>
            <input className="holiday-input" type="text" value={this.state.name} onChange={this.handleNameChange} />
            <p className="form-label white">{'Email'}</p>
            <input className="holiday-input"  type="text" value={this.state.email} onChange={this.handleEmailChange} />
            <p className="form-label white">{'T Shirt Size'}</p>
            <input className="holiday-input"  type="text" value={this.state.tShirtSize} onChange={this.handleTShirtSizeChange} />
            <div style={{paddingTop:"20px",paddingBottom:"20px"}}>
              <div onClick={this.submitForm} className="full-width button white-background black centered-text">{'Enter Contest'}</div>
            </div>
          </div>}
          {this.state.messageSent && <div className="success-container full-width">
            <div className="success-container-text full-width large-padding centered-text">
              <h4 className="full-width white centered-text">{'Your Entry Has Been Received'}</h4>
            </div>
          </div>}
        </div>
      </div>
		)
	}
}
//@ts-ignore
export default HolidayForm;
